
<template>
	<div class="sys-enterprise header-padding">
		<f-page-header />

		<div class="a-card" v-loading="loading">
			<el-card class="card-container" shadow="never">
				<div class="font-lg">{{ '基本信息' }}</div>
				<div class="b-card">
					<div class="image-editor">
						<el-avatar :size="100" :src="$store.state.godStore.logo" shape="square">
							<img src="@/assets/logo.png" />
						</el-avatar>
						<el-upload :action="$store.state.commonStore.fileUploadUrl" :file-list="consoleImgFile" :show-file-list="false" :before-upload="beforeConsoleImgUpload" :on-success="setConsoleImg" style="display: inline-block">
							<div class="mask flex-center">修改</div>
						</el-upload>
					</div>

					<div class="ml-lg">
						<div class="text-bold font-2x">{{ god.short_name }}</div>
						<div class="mt">{{ god.full_name }}</div>
					</div>
					<div class="b-btn">
						<el-button type="success" plain @click="editName">编辑</el-button>
					</div>
				</div>
			</el-card>

			<el-card class="card-container" shadow="never">
				<div class="font-lg">{{ '系统管理员' }}</div>
				<div class="b-card">
					<f-user-avatar :user="owner" size="huge"></f-user-avatar>

					<div class="ml-lg">
						<div class="text-bold font-2x">{{ owner.username }}</div>
						<div class="mt number">{{ owner.mobile }}</div>
					</div>
					<div class="b-btn">
						<el-button type="success" plain @click="changeManager">切换</el-button>
					</div>
				</div>
			</el-card>
		</div>

		<sys-user-picker v-if="showPicker" :show.sync="showPicker" :uid="owner.uid" @onUserPicked="pickerSysM"></sys-user-picker>
	</div>
</template>

<script>
import { changegManagerApi } from '@/api/sys/enterpriseApi'
export default {
	name: 'SysEnterprise',
	components: {
		SysUserPicker: () => import('./components/SysUserPicker.vue')
	},
	data () {
		return {
			loading: false,
			logoUploaderShow: false,
			// god: {},
			showPicker: false,
			consoleImgFile: []
		}
	},
	computed: {
		god () {
			return this.$store.state.godStore.god
		},
		owner () {
			return this.$store.state.godStore.owner
		}
	},
	methods: {
		editName () {
			this.$prompt('请输入新的简称', '企业简称修改', {
				closeOnClickModal: false,
				inputErrorMessage: '请输入正确格式',
				inputValue: this.god.short_name
			})
				.then(({ value }) => {
					this.$store.dispatch('setGodInfomationAction', { short_name: value }).then(res => {
						if (!res.errno) {
							this.$message.success(res.message)
						} else {
							this.$message.error(res.message)
						}
					})
				})
				.catch(() => {
					// 取消
				})
		},

		beforeConsoleImgUpload (file) {
			const formatArr = ['image/jpeg', 'image/png']
			if (formatArr.indexOf(file.type) === -1) {
				this.$message.error('上传图片格式只能是 jpg 或 png！')
				return false
			}
			if (file.size > 2048 * 1024) {
				this.$message.error('上传图片大小不能超过 2M')
				return false
			}
			this.loading = true
			return true
		},

		changeManager () {
			this.showPicker = true
		},

		changeIcon () {
			this.logoUploaderShow = true
		},

		setConsoleImg (res) {
			this.$store.dispatch('setGodInfoAction', { logo: res.data.url }).then(r => {
				this.loading = false
				if (!r.errno) {
					this.$message.success(r.message)
				} else {
					this.$message.error(r.message)
				}
			})
		},

		pickerSysM (item) {
			if (item.uid == this.owner.uid) return

			changegManagerApi({ uid: item.uid }).then(res => {
				if (!res.errno) {
					this.$message.success(res.message)
					this.$store.dispatch('fedLogOut').then(() => {
						location.reload()
					})
				} else {
					this.$message.error(res.message)
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.sys-enterprise {
	.a-card {
		min-height: 720px;
		margin: 20px auto;
		width: 1180px;

		.card-container {
			height: 280px;
			padding: 4px 15px;
			margin-top: 20px;
			.b-card {
				position: relative;
				display: flex;
				align-items: center;
				margin: 61px 85px 45px 85px;
				.image-editor {
					position: relative;
					width: 100px;
					height: 100px;

					.el-avatar {
						position: absolute;
						background: transparent;
						top: 0;
						left: 0;
					}
					.mask {
						position: absolute;
						width: 100%;
						height: 100%;
						left: 0;
						top: 0;
						// border-radius: 50%;
						cursor: pointer;
						color: #f9f9f9;
						background-color: rgba(0, 0, 0, 0.5);
						opacity: 0;
						transition: opacity 0.3s;
						&:hover {
							opacity: 1;
						}
					}
				}
				.b-btn {
					position: absolute;
					right: 0px;
				}
			}
		}
	}
}
</style>